import { Validator } from "./types";
import { SearchContextType } from "../search-context";
import ValidationErrorMessages from "./error-messages";

const validateAddressPersonSearch: Validator = (data: SearchContextType) => {
  const {
    firstName,
    lastName,
    fullAddress,
    dateOfBirth,
    middleNames,
    organisationName,
    organisationHouseNumber,
    organisationPostCode,
    organisationType,
    organisationGmcNumber,
    drivingLicenseNumber,
    emailAddress,
    telNo,
    mobileTelNo,
    nationalInsuranceNumber,
    passportNumber,
    registrationNumber,
    vinNo,
  } = data;

  const hasValidName =
    firstName?.trim().length > 1 && lastName?.trim().length > 0;
  const hasAddress = !!fullAddress?.trim();
  const hasDob = !!dateOfBirth?.toString().trim();

  const allOtherFieldsEmpty = [
    middleNames,
    organisationName,
    organisationPostCode,
    organisationType,
    drivingLicenseNumber,
    emailAddress,
    organisationHouseNumber,
    organisationGmcNumber,
    telNo,
    mobileTelNo,
    nationalInsuranceNumber,
    passportNumber,
    registrationNumber,
    vinNo,
  ].every((val) => (typeof val === "string" ? val.trim() === "" : val == null));

  const doSearch = hasValidName && hasDob && hasAddress && allOtherFieldsEmpty;

  return doSearch
    ? { isValid: true, errors: [] }
    : {
        isValid: false,
        errors: [ValidationErrorMessages.invalidPersonAddress],
      };
};

export default validateAddressPersonSearch;
